<template>
  <transition name="component-fade">
    <b-icon icon="three-dots" animation="cylon" font-scale="4"></b-icon>
  </transition>
</template>
<script>
export default {
  name: 'loading-import',
}
</script>
